import * as commonAPI from '@/api/commonApi';
import * as API from '@/api/tokyoOlympicApi';
import * as winterOlympicApi from '@/api/winterOlympicApi';
import utils from '@/utils/utils';
import {packConfig} from '@/page/tokyoOlympic/config';
import moment from 'moment';

const state = {
  number: '--',// 抽奖机会
  shareStatus: 0,// 分享任务完成状态 3：未分享 1：已分享，奖励已领取 2：已分享奖励，未领取
  loginStatus: null,// 当日登录任务完成状态 1：当日还未登录 2：已登录，奖励未领取 3：已登录，奖励已领取
  totalTime: '', //累计玩游戏时长
  packList: [],//玩游戏时长奖励领取状态
  inMiguApp: utils.isMiguApp(),
  records: [],// 获奖记录
  prizeInfo: {},// 抽取的奖品
  gameList: [],// 游戏列表
  gameTaskStatus: null,
  medalInfo:{},
  rewardStatus:null,
  queryTaskInfoFlag:0
}

const actions = {

}

const mutations = {
  async getLotteryNumber(state, param) {
    try{
      const res = await commonAPI.getLotteryNumber(param);
      const { returnCode, resultData, message } = res.data;
      if(returnCode === '000000') {
        state.number = resultData;
      }else { 
        utils.popMessage(message);
      }
    } catch(err){
      console.log(err);
    }
  },
  // 查询任务列表接口
  async getTaskInfo(state) {
    try{
      const res = await winterOlympicApi.queryTaskInfo();
      const { returnCode, resultData, message } = res.data;
      if(returnCode === '000000') {
        const { shareTaskStatus, loginTaskStatus, totalGameTime, totalGameTasks ,dailyGameTaskStatus} = resultData;
        state.gameTaskStatus = dailyGameTaskStatus;   // 每日游戏任务状态（-1：未完成 0：任务已完成，奖励未领取 1：奖励已领取
        state.shareStatus = shareTaskStatus;  // 分享任务状态（-1：未完成 0：任务已完成，奖励未领取 1：奖励已领取）
        state.loginStatus = loginTaskStatus;  // 登录任务状态（-1：未完成 0：任务已完成，奖励未领取 1：奖励已领取）
        state.totalTime = utils.time2format(totalGameTime, 'cn');
        state.queryTaskInfoFlag = 1
        state.packList = packConfig.map(item => {
          const { taskType } = item;
          const statusParam = totalGameTasks.find(i => i.taskType == taskType);  // totalGameTasks：累计游戏任务列表
          const {commonReceiveFlag, memberReceiveFlag} = statusParam || {};  // （0：未领取 1：已领取）
          // 根据时间收到计算下已达标状态
          const active = statusParam && commonReceiveFlag==0;
          const vipActive = statusParam && memberReceiveFlag==0;  
          return {
            ...item,
            ...statusParam,
            active,
            vipActive,
          }
        });
      } else if( returnCode ==="060159") {
          console.log(message);
      }else { 
        utils.popMessage(message);
      }
    } catch(err){
      console.log(err);
    }
  },
  //   获取获奖用户列表
  async getRecords(state, param){
    try{
      const res = await commonAPI.getUserList(param);
      const { returnCode, resultData, message } = res.data;
      if(returnCode === '000000') {
        state.records = resultData;
      }else { 
        utils.popMessage(message);
      }
    } catch(err){
      console.log(err);
    }
  },
  setPrizeInfo(state, param) {
    state.prizeInfo = param;
  },

    // 分享上报服务端
  async reportShare(state) {
    // 上报服务端
    try{
      const res = await winterOlympicApi.reportShare();
      this.commit('activity/getTaskInfo');
      const { returnCode, resultData, message } = res.data;
      if(returnCode === '000000') {
        // if(!resultData){
        //   utils.popMessage('您不是首次分享哦！');
        // }
      }else { 
        utils.popMessage(message);
      }
    } catch(err){
      console.log(err);
    }
  },

//   获取游戏列表接口
  async queryRecommendGame() {
    try{
      const res = await winterOlympicApi.queryRecommendGame();
      const { returnCode, resultData, message } = res.data;
      if(returnCode === '000000') {
        state.gameList = resultData;
        
      }else { 
        utils.popMessage(message);
      }
    } catch(err){
      console.log(err);
    }
  },
  // 查询东奥勋章接口
  async queryMedal() {
    try{
      const res = await winterOlympicApi.queryMedal();
      const { returnCode, resultData, message } = res.data;
      if(returnCode === '000000') {
        const { receiveFlag, medalInfo, receiveTimestamp } = resultData;
        state.medalInfo = {
          ...resultData,
          medalStatus: receiveFlag,  //勋章领取状态
          medalTime: moment(receiveTimestamp).format('YYYY-MM-DD'),
        };
      }else { 
        utils.popMessage(message);
      }
    } catch(err){
      console.log(err);
    }
  },

  // 奖励领取接口
  async rewardCollection(state, param){
    const {isVipPack, taskType, activityId, activityFlag} = param; 
    try{
      const res = await winterOlympicApi.rewardCollection({
        /**
         *  
         * taskType：
         任务类型（ -1: 分享，0: 玩推荐游戏15分钟，
         1: 登录，
         2 4 6 8 …… 玩游戏 2,4,6,8……小时）body里取
         */
        taskType,  
        vipFlag: isVipPack?1:0,
      });
      // 更新状态
      setTimeout(() => {
        this.commit('activity/getTaskInfo');
        this.commit('activity/getLotteryNumber', {
          activityId,
          activityFlag,
        });
        if(taskType == 3){
          // 玩游戏领奖励，刷新时调推荐列表接口
          this.commit('activity/queryRecommendGame');
        }
      }, 100);
      const { returnCode, resultData, message } = res.data;
      state.rewardStatus = (returnCode == "000000")
      if(returnCode === '000000') {
        // if(!resultData){
        //   utils.popMessage('领取失败');
        // }
      }else { 
        utils.popMessage(message);
      }
    } catch(err){
      console.log(err);
    }
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/activity.js